module.exports = __webpack_public_path__ + "static/media/arrow-down.d9faec5d.svg";